module.exports = __webpack_public_path__ + "assets/b116.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b116.png
// module id = 588
// module chunks = 0